import styled from 'styled-components'
import { Link as LinkStyles } from '@chegg-wt/core/theme/sunkist/link'
import { BibliographyUpsellCopy } from '@chegg-wt/core/types/features'
import { Config } from '@chegg-wt/core/config'
import { BibliographyB1Copy } from '@chegg-wt/core/types/copy'

export const Link = styled.a`
  ${LinkStyles};
`

export const upsellCopy: BibliographyUpsellCopy = {
  plagiarism: {
    UPSELL_HEADING: 'Writing help from start to finish',
    CTA_COPY: 'Try Cite This For Me Plus*',
    FEATURE_LIST: [
      'Unlimited plagiarism & grammar checks',
      'Summarized feedback from writing experts',
      '7,000+ styles including APA & Chicago',
    ],
    IMAGE_ALT_TEXT: 'plagiarism detected paper',
  },
}

export const bibliographyB1: BibliographyB1Copy = {
  title: 'More writing resources for you!',
  contents: [
    {
      header: 'Choose a different citation style',
      body: () => (
        <>
          Odds are, you’ve been assigned a specific citation style to use by your teacher,
          publication, editor, or colleague. Did you know there are literally thousands of
          citation styles in the world? Fortunately, Cite This For Me™ has a lot of them!
          Click on the “Change style” button to search for and select your designated
          citation style. If you have the freedom to choose the style you use, try{' '}
          <Link
            target="_blank"
            href={`${Config.baseUrl}/uk/referencing-generator/harvard`}
          >
            Harvard referencing
          </Link>
          ,{' '}
          <Link target="_blank" href={`${Config.baseUrl}/us/citation-generator/mla`}>
            MLA format
          </Link>
          , or{' '}
          <Link target="_blank" href={`${Config.baseUrl}/us/citation-generator/apa`}>
            APA citation
          </Link>{' '}
          format. These are the most popularly used styles on CiteThisForMe.com.
        </>
      ),
    },
    {
      header: 'Add the Cite This For Me™ Chrome extension',
      body: () => (
        <>
          Use Google Chrome? If yes, add our intuitive Cite This For Me™ Chrome extension
          and gain the power to automatically cite a web page when you’re actually on it!
          Whenever you’re on a page you want to cite, simply click the Cite This For Me™
          extension button to generate a citation for it. It’s quick, easy, and free!{' '}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/cite-this-for-me-web-cite/nnnmhgkokpalnmbeighfomegjfkklkle"
          >
            Click here
          </Link>{' '}
          to get the extension.
        </>
      ),
    },
    {
      header: 'Export your citation list',
      body: () => (
        <>
          Once you’ve completed your bibliography or reference list, it’s time to export
          it! Copy and paste your citations from Cite This For Me™ into your paper,
          project, or document. If you’re looking to export it as a Word Doc, a premium
          account may be a good fit for you.
        </>
      ),
    },
    {
      header: 'Try Cite This For Me™ Premium',
      body: () => (
        <>
          If you like to save work as you progress, dislike ads, and prefer to download
          your bibliography as a Word Doc, Cite This For Me™ premium access is perfect for
          you! In addition to the perks already mentioned, you’ll also gain access to a
          plagiarism checker. It helps you identify any information that may still need a
          citation created for it. To sum it all up: Cite. Save. Download. Check. Sign up
          by <Link href={`${Config.baseUrl}/register`}>clicking here</Link>.
        </>
      ),
    },
    {
      header: 'Take a break and read our blog',
      body: () => (
        <>
          Citing is great, but it isn’t the most exciting thing in the world. If you’ve
          cited so much that your eyes are getting crossed, take a break and check out our
          blog! We cover questions about citing and writing that you’ve always wondered
          about, and you’ll have fun along the way. Keep up with the latest articles and
          updates by following us on{' '}
          <Link target="_blank" href="https://www.facebook.com/CiteThisForMe/">
            Facebook
          </Link>{' '}
          or{' '}
          <Link target="_blank" href="https://twitter.com/CiteThisForMe">
            Twitter
          </Link>
          .
        </>
      ),
    },
  ],
}
